import NamedDto from 'modules/base/dto/NamedDto';
import SensorValueEditDto from './SensorValueEditDto';

export class SensorTypeEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.manufacturer = null;
		/** @type {string} */
		this.modelId = null;
		/** @type {SensorValueEditDto[]} */
		this.valueList = null;
		/** @type {number} */
		this.externalId = null;
		/** @type {number} */
		this.maxSamplingRate = null;
		/** @type {number[]} */
		this.edaTypeList = null;
	}

	/**
	 * @typedef {Object} _SensorTypeEditDtoProps
	 * @property {string} manufacturer
	 * @property {string} modelId
	 * @property {SensorValueEditDto[]} valueList
	 * @property {number} externalId
	 * @property {number} maxSamplingRate
	 * @property {number[]} edaTypeList
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _SensorTypeEditDtoProps} SensorTypeEditDtoProps
	 */
	/**
	 *
	 * @param {SensorTypeEditDtoProps} props
	 * @returns {SensorTypeEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.manufacturer = props.manufacturer;
		this.modelId = props.modelId;
		this.valueList = props.valueList !== null ? props.valueList.map(d => new SensorValueEditDto().setup(d)) : [];
		this.externalId = props.externalId;
		this.maxSamplingRate = props.maxSamplingRate;
		this.edaTypeList = props.edaTypeList;
		return this;
	}
}

export default SensorTypeEditDto;
